<template>
    <div id="pg-header">
        <div class="ui-h">
            <div class="ly-c">
                <div class="ly-m">
                    <div class="cinfo">
                        <ul>
                            <li><span class="iconfont icon-youxiang1"></span>{{ headerData.email || '' }}</li>
                            <li><span class="iconfont icon-dizhi"></span>{{ headerData.address || '' }}</li>
                        </ul>
                    </div>
                    <div class="share">
                        <ul>
                            <li>{{ $t('common.fenxiang') }}</li>
                            <li><a href="javascript:;" @click="shareTo('tiktok', currentLang.value)"><i class="iconfont icon-tiktok"></i></a></li>
                            <li><a href="javascript:;" @click="shareTo('x', currentLang.value)"><i class="iconfont icon-x"></i></a></li>
                            <li><a href="javascript:;" @click="shareTo('facebook', currentLang.value)"><i class="iconfont icon-facebook"></i></a></li>
                            <li><a href="javascript:;" @click="shareTo('ins', currentLang.value)"><i class="iconfont icon-ins"></i></a></li>
                            <li><a href="javascript:;" @click="shareTo('linkedin', currentLang.value)"><i class="iconfont icon-lingying"></i></a></li>
                        </ul>  
                    </div>
                </div>
            </div>
        </div>
        <div class="ui-c">
            <div class="ly-c">
                <div class="ly-m">
                    <div class="fn-difall">
                        <div class="logo"><router-link to="/"><img src="@/assets/images/logo.png" alt="网站logo" /></router-link></div>
                        <div class="nav">
                            <ul>
                                <li :class="{ curr: $route.path === '/' || $route.path === '/index' }">
                                <router-link to="/index">{{ $t('common.home') }}</router-link>
                                </li>
                                <li :class="{ curr: $route.path === '/about' }">
                                <router-link to="/about">{{ $t('common.about') }}</router-link>
                                </li>
                                <li :class="{ curr: $route.path === '/service' }">
                                <router-link to="/service">{{ $t('common.services') }}</router-link>
                                </li>
                                <!-- 🔥 核心修改：用 startsWith 判断 /news 前缀 -->
                                <li :class="{ curr: $route.path.startsWith('/news') }">
                                <router-link to="/news">{{ $t('common.news') }}</router-link>
                                </li>
                                <li :class="{ curr: $route.path === '/contact' }">
                                <router-link to="/contact">{{ $t('common.contact') }}</router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="oth">
                            <ul>
                                <li>
                                <a href="javascript:;" @click="handleSwitchLang('zh-CN')" :class="{ active: currentLang === 'zh-CN' }">
                                    <img src="@/assets/images/china.png" /> {{ $t('common.chinese') }}
                                </a>
                                </li>
                                <li>
                                <a href="javascript:;" @click="handleSwitchLang('en')" :class="{ active: currentLang === 'en' }">
                                    <img src="@/assets/images/australia.png" /> {{ $t('common.english') }}
                                </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // 原有导入（不变）
    import axios from 'axios'
    import cmapi from '@/config/api.js'
    import { ref, onMounted, onErrorCaptured, watch } from 'vue'
    import { useLang } from '@/composables/useLang'
    import { useRoute } from 'vue-router'

    // 🔥 新增：导入全局分享组合式函数（关键，从 composables 目录导入）
    import { useShare } from '@/composables/useShare'

    export default {
    name: 'CmHeader',
    setup() {
        // 原有逻辑（不变）
        const { lang, setLang } = useLang()
        const currentLang = lang
        const route = useRoute()
        
        const headerData = ref({
        email: '',
        address: ''
        })

        // 🔥 新增：初始化全局分享函数（调用 useShare()，获取里面的 shareTo 方法）
        const { shareTo } = useShare()

        // 原有逻辑：加载头部数据（不变）
        const loadHeaderData = async () => {
        try {
            const apiUrl = cmapi?.baseUrl 
            ? `${cmapi.baseUrl}/comm/header.php` 
            : '/api/comm/header.php';
            
            const res = await axios.get(apiUrl, {
            params: { lang: currentLang.value },
            timeout: 3000,
            cache: false
            })
            
            if (res.data.code === 200) {
            headerData.value = {
                email: res.data.data.email || '',
                address: res.data.data.address || ''
            }
            }
        } catch (error) {
            headerData.value = { email: '', address: '' }
        }
        }

        // 原有逻辑：语言切换（不变）
        const handleSwitchLang = (langVal) => {
        setLang(langVal)
        loadHeaderData()
        }

        // 原有逻辑：监听语言变化（不变）
        watch(currentLang, (newLang) => {
        if (newLang) {
            loadHeaderData()
        }
        })

        // 原有逻辑：错误捕获（不变）
        onErrorCaptured((err) => {
        console.log('header组件错误：', err)
        return true
        })

        // 原有逻辑：挂载加载（不变）
        onMounted(() => {
        setTimeout(loadHeaderData, 100)
        })

        // 原有返回值（不变）+ 🔥 新增返回 shareTo 方法（供模板调用）
        return {
        currentLang,
        handleSwitchLang,
        headerData,
        route,
        shareTo // 必须返回，模板中的 @click 才能调用到这个方法
        };
    }
    };
</script>

<style lang="scss">
    #pg-header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 500;
        .ui-h {
            width: 100%;
            border-bottom: 1px solid rgba(255,255,255,0.15);
            &::after {
                content: "";
                display: block;
                clear: both;
            }
            .ly-m {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .cinfo {
                float: left;
            }
            .share {
                float: right;
                // 🔥 新增：分享图标hover样式
                li {
                    cursor: pointer;
                    &:hover i {
                        color: var(--fontred); // 与现有主题色统一
                        transition: color 0.3s ease;
                    }
                }
            }
            ul {
                display: flex;
                align-items: center;
                margin: 0;
                padding: 0;
                list-style: none;
            }
            li {
                color: #fff;
                display: flex;
                align-items: center;
                height: 40px;
                padding: 0 1rem;
                font-size: 0.86rem;
                text-transform: uppercase;
                border-right: 1px solid rgba(255,255,255,0.15);
                &:last-child {
                    border-right: 0 none;
                }
            }
            .iconfont {
                margin-right: 5px;
            }
            i {
                color: #fff;
                font-size: 1.4rem;
            }
        }
        .ui-c {
            .fn-difall {
                height: 90px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .logo {
                img {
                    height: 3rem;
                    vertical-align: middle;
                }
            }
            .nav {
                ul {
                    display: flex;
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                li {
                    margin: 0 0.4rem;    
                }
                a {
                    color: #fff;
                    display: inline-flex;
                    height: 36px;
                    padding: 0 1.3rem;
                    align-items: center;
                    font-size: 1.1rem;
                    text-decoration: none;
                    justify-content: center;
                    text-transform: uppercase;
                    border-radius: 40px;
                    &:hover {
                        color: var(--fontred);
                    }
                }
                li.curr a {
                    color: #ffffff;
                    background-color:var(--bgred);
                }
            }
            .oth {
                ul {
                    display: flex;
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                li {
                    margin-left: 10px;
                }
                a {
                    color: #fff;
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    font-size: 0.9rem;
                    text-decoration: none;
                    &.active {
                        color:var(--fontred);
                    }
                    &:hover {
                        color:var(--fontred);
                    }
                }
                img {
                    height: 1.2rem;
                    vertical-align: middle;
                }
            }
        }
    }
    @media (min-width: 0px) and (max-width: 479px) {
        #pg-header {
            padding: 0 0 1rem 0;
            background-color: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            .ui-h {
                display: none;
                .cinfo {display: none;}
                .share {
                    li {
                        height: 2rem;
                        padding: 0 0.5rem;
                    }
                    i {
                        font-size: 1.2rem;
                    }
                }
            }
            .ui-c {
                .fn-difall {
                    height: auto;
                    padding:1rem 0 0;
                    .nav {
                        display: none;
                    }
                }
                .logo {
                    float: left;
                    img {
                        height: 2.5rem;
                    }
                }
                .oth {
                    float: right;
                }
            }
        }
    }
    @media (min-width: 480px) and (max-width: 639px) {
            #pg-header {
            padding: 0 0 1rem 0;
            background-color: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            .ui-h {
                display: none;
                .cinfo {display: none;}
                .share {
                    li {
                        height: 2rem;
                        padding: 0 0.5rem;
                    }
                    i {
                        font-size: 1.2rem;
                    }
                }
            }
            .ui-c {
                .fn-difall {
                    height: auto;
                    padding:1rem 0 0;
                    .nav {
                        display: none;
                    }
                }
                .logo {
                    float: left;
                    img {
                        height: 2.5rem;
                    }
                }
                .oth {
                    float: right;
                }
            }
        }
    }
    @media (min-width: 640px) and (max-width: 959px) {
            #pg-header {
            padding: 0 0 1rem 0;
            background-color: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
            .ui-h {
                .cinfo {display: none;}
                .share {
                    li {
                        height: 2rem;
                        padding: 0 0.5rem;
                    }
                    i {
                        font-size: 1.2rem;
                    }
                }
            }
            .ui-c {
                .fn-difall {
                    height: auto;
                    padding:1rem 0 0;
                    .nav {
                        display: none;
                    }
                }
                .logo {
                    float: left;
                    img {
                        height: 2.5rem;
                    }
                }
                .oth {
                    float: right;
                }
            }
        }
    }
    @media (min-width: 960px) and (max-width: 1279px) {
        #pg-header {
            .ui-h {
                .share {
                    display: none;
                }
            }
            .ui-c {
                .nav {
                    li {
                        margin: 0;
                        padding: 0;
                        a {
                            font-size: 1rem;
                        }
                    }
                }
            }
        }
    }
</style>